<template>
  <c-step
    stepperGrpCd="EDU_STEP_CD"
    :currentStepCd="popupParam.stepCd"
    :param="param"
    v-model="popupParam.stepCd"
    @closePopup="closePopup"
    @currentStep="currentStep"
    @currentStatus="currentStatus"
    @stepClick="stepClick"
    >
  </c-step>
</template>

<script>
import { uid } from 'quasar'
export default {
  name: 'education-result-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        plantCd: null,
        eduEducationId: '',
        stepCd: '',
        educationKindCdLarge: null,
        delAuth: '',
      }),
    },
  },
  data() {
    return {
      editable: true,
      completeSt : '',
      documentStatusCd: '',
    };
  },
  computed: {
    param() {
      return {
        plantCd: this.popupParam.plantCd,
        eduCourseId: this.popupParam.eduCourseId,
        eduEducationId: this.popupParam.eduEducationId,
        educationKindCdLarge: this.popupParam.educationKindCdLarge,
        stepCd: this.popupParam.stepCd,
        completeSt: this.completeSt,
        documentStatusCd: this.documentStatusCd,
        delAuth: this.popupParam.delAuth,
      }
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    currentStep(data) {
      this.popupParam.stepCd = data.step;
      this.popupParam.eduEducationId = data.key;
    },
    currentStatus(status) {
      this.documentStatusCd = status;
    },
    closePopup() {
      this.$emit('closePopup')
    },
    stepClick() {
      this.completeSt = uid();
    }
  }
};
</script>
